import React, { useContext, useEffect } from "react";
import { Table, Icon, Button, Popup } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { ISellerForm } from "../../../app/models/seller";
import EditSellerForm from "./EditSellerForm";
import { SellerStateEnum } from "../../../app/util/sellerStateEnum";
import { getSellerStateText } from "../../../app/util/sellerStateEnumOptions";

const ListSellers = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { getSellers, sellers, loadData, changeSellerState } = rootStore.sellerStore;
  const { openModal } = rootStore.modalStore;

  useEffect(() => {
    getSellers();
  }, [getSellers]);

  const handleChangeState = (s: ISellerForm, state: SellerStateEnum) => {
    changeSellerState({ id: s.id, state: state });
  };

  if (!loadData) return <LoadingComponent content="Cargando" />;

  return (
    <div className="TableScroll">
    <Table striped basic unstackable compact singleLine>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Nombre</Table.HeaderCell>
          <Table.HeaderCell>Identificación</Table.HeaderCell>
          <Table.HeaderCell>Teléfono</Table.HeaderCell>
          <Table.HeaderCell>Mail notificaciones</Table.HeaderCell>
          <Table.HeaderCell>Estado</Table.HeaderCell>
          <Table.HeaderCell>Acciones</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {sellers?.length > 0 ? (
          sellers.map((s) => (
            <Table.Row key={s.id}>
              <Table.Cell>{s.fullName}</Table.Cell>
              <Table.Cell>{s.identification}</Table.Cell>
              <Table.Cell>{s.phone}</Table.Cell>
              <Table.Cell>{s.email}</Table.Cell>
              <Table.Cell>{getSellerStateText(s.state)}</Table.Cell>
              <Table.Cell>
                {s.state === SellerStateEnum.Active ? (
                  <div>
                    <Popup
                      content="Editar Vendedor"
                      trigger={
                        <Button
                          icon
                          onClick={() =>
                            openModal(
                              <EditSellerForm seller={s} />,
                              "Editando vendedor"
                            )
                          }
                        >
                          <Icon name="edit outline" color="blue" />
                        </Button>
                      }
                    />
                    <Popup
                      content="Click para Inactivar vendedor"
                      trigger={
                        <Button icon onClick={() => handleChangeState(s, SellerStateEnum.Inactive)}>
                          <Icon name="unlock" color="green" />
                        </Button>
                      }
                    />
                  </div>
                ) : (
                  <div>
                    <Button icon disabled>
                      <Icon name="edit outline" color="blue" />
                    </Button>

                    <Popup
                      content="Click para Activar vendedor"
                      trigger={
                        <Button icon onClick={() =>  handleChangeState(s, SellerStateEnum.Active)}>
                          <Icon name="lock" color="red" />
                        </Button>
                      }
                    />
                  </div>
                )}
              </Table.Cell>
            </Table.Row>
          ))
        ) : (
          <Table.Row key="sellersNull">
            <Table.Cell>No existen Vendedores </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
    </div>
  );
};

export default observer(ListSellers);
